import { formatIDR, formatDate } from "@/lib/api";

const angka = ["", "satu", "dua", "tiga", "empat", "lima", "enam", "tujuh", "delapan", "sembilan", "sepuluh", "sebelas"];
function terbilang(n) {
  n = Math.floor(Math.abs(Number(n) || 0));
  if (n === 0) return "nol";
  if (n < 12) return angka[n];
  if (n < 20) return terbilang(n - 10) + " belas";
  if (n < 100) {
    const rem = n % 10;
    return terbilang(Math.floor(n / 10)) + " puluh" + (rem ? " " + terbilang(rem) : "");
  }
  if (n < 200) {
    const rem = n - 100;
    return "seratus" + (rem ? " " + terbilang(rem) : "");
  }
  if (n < 1000) {
    const rem = n % 100;
    return terbilang(Math.floor(n / 100)) + " ratus" + (rem ? " " + terbilang(rem) : "");
  }
  if (n < 2000) {
    const rem = n - 1000;
    return "seribu" + (rem ? " " + terbilang(rem) : "");
  }
  if (n < 1000000) {
    const rem = n % 1000;
    return terbilang(Math.floor(n / 1000)) + " ribu" + (rem ? " " + terbilang(rem) : "");
  }
  if (n < 1000000000) {
    const rem = n % 1000000;
    return terbilang(Math.floor(n / 1000000)) + " juta" + (rem ? " " + terbilang(rem) : "");
  }
  const rem = n % 1000000000;
  return terbilang(Math.floor(n / 1000000000)) + " milyar" + (rem ? " " + terbilang(rem) : "");
}
const terbilangRupiah = (n) => (terbilang(n).replace(/\s+/g, " ").trim() + " rupiah").replace(/^./, (c) => c.toUpperCase());

const Row = ({ label, value }) => (
  <div className="flex items-baseline gap-3">
    <div className="w-[140px] shrink-0">{label}</div>
    <div className="shrink-0">:</div>
    <div className="flex-1 border-b border-dotted border-black min-h-[20px] font-medium">{value}</div>
  </div>
);

/**
 * Printable payoff (Pelunasan) receipt.
 * Props: sale, settings, amount (number), date (YYYY-MM-DD)
 */
export default function PayoffReceipt({ sale, settings, amount, date, onDone }) {
  if (!sale || !settings) return null;
  return (
    <div className="print-only" onAnimationEnd={onDone}>
      <div className="flex justify-between items-start">
        <div className="flex items-center gap-3">
          {settings.logo_url && <img src={settings.logo_url} alt="Logo" className="w-16 h-16 object-contain" />}
          <div className="font-bold text-3xl" style={{ fontFamily: "serif" }}>KWITANSI</div>
        </div>
        <div className="text-right">
          <div className="text-sm">No. <span className="font-mono-num font-semibold">{sale.account_number}</span></div>
          <div className="text-sm">JENIS: <span className="font-mono-num">PELUNASAN</span></div>
        </div>
      </div>
      <div className="mt-3 border-t border-black" />
      <div className="text-center mt-3">
        <div className="font-bold text-xl" style={{ fontFamily: "serif" }}>{settings.name}</div>
        <div className="text-xs mt-1 leading-relaxed">
          {settings.address_office && <div>Kantor: {settings.address_office} · Telp {settings.phone_office}</div>}
          {settings.address_home && <div>Rumah: {settings.address_home} · Telp {settings.phone_home}</div>}
        </div>
      </div>
      <h2 className="text-center font-bold text-xl mt-4 underline" style={{ fontFamily: "serif" }}>TANDA TERIMA PELUNASAN</h2>
      <div className="mt-6 text-[14px]">Telah terima pembayaran pelunasan sebagai berikut :</div>
      <div className="mt-4 space-y-3 text-[14px]">
        <Row label="Dari" value={sale.customer?.name || "-"} />
        <Row label="Alamat" value={sale.customer?.address || "-"} />
        <Row label="Kendaraan/Th" value={`${sale.car?.brand || ""} ${sale.car?.model || ""} / ${sale.car?.year || ""}`} />
        <Row label="No. Polisi" value={sale.car?.plate_number || "-"} />
        <Row label="Keterangan" value="Pelunasan seluruh sisa angsuran" />
        <Row label="Sebesar" value={`Rp. ${formatIDR(amount).replace("Rp","").trim()}`} />
      </div>
      <div className="mt-3 text-[13px] italic"># {terbilangRupiah(amount)} #</div>
      <div className="mt-8 text-right text-sm">{settings.city}, Tgl <span className="inline-block border-b border-black min-w-[140px] text-center font-mono-num">{formatDate(date)}</span></div>
      <div className="mt-10 grid grid-cols-3 gap-6 text-center text-[13px]">
        {[1, 2, 3].map((n) => (
          <div key={n}>
            <div className="italic">{settings[`signatory${n}_label`] || `Penerima ${n}`}</div>
            <div className="h-16" />
            <div className="border-t border-black pt-1 font-semibold">
              ( {settings[`signatory${n}_name`] || "____________"} )
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
